import { Inject, Injectable } from '@angular/core';

import type { IAppConfig } from '@recruitee/common';
import { APP_CONFIG } from '@recruitee/common';
import type { AuthorisationStrategy } from '@recruitee/http';
import { CookieKey, CookieService } from '@recruitee/http';

@Injectable()
export class RecruiteeAuthStrategy implements AuthorisationStrategy {
  constructor(
    @Inject(APP_CONFIG) public appConfig: IAppConfig,
    private cookieService: CookieService,
  ) {}

  public onAuthorizationFailed(response?: any): void {
    this.clearAuthCookies();

    if (!response) return;

    if (response && response.status === 422) {
      this.redirectToBlockedAccount();
    } else {
      this.redirectToAuth();
    }
  }

  public onUnauthorized(): void {
    this.clearAuthCookies();
    this.redirectToAuth();
  }

  public onForbidden(error: any, companyId: number, url: string): void {
    const urlParts = url.split(`${companyId}`);
    if (urlParts && urlParts[1] === '/admin') {
      this.clearAuthCookies();
      this.redirectToBlockedAccount();
    }
  }

  private getAuthUrl(): string {
    return this.appConfig.authUrl;
  }

  private getAppUrl(): string {
    return this.appConfig.appUrl;
  }

  private redirectToAuth(): void {
    window.location.replace(
      this.getAuthUrl() + `?redirect=${encodeURIComponent(window.location.href)}`,
    );
  }

  private clearAuthCookies(): void {
    this.cookieService.delete(CookieKey.SuperadminAccessToken);
    this.cookieService.delete(CookieKey.AccessToken);
    this.cookieService.delete(CookieKey.Company);
  }

  private redirectToBlockedAccount(): void {
    this.cookieService.delete(CookieKey.AccessToken);
    window.location.replace(
      this.getAuthUrl() +
        `sign-out?redirect_to=${encodeURIComponent(this.getAppUrl() + 'account-blocked')}`,
    );
  }
}
